import ShipFromTab from './ShipFromTab';
import { withI18n } from 'react-i18next';

export default withI18n()(ShipFromTab);
